import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Page } from "./types";
import Footer from "components/Footer/Footer";
import MusicPlayer from "components/MusicPlayer/MusicPlayer";
import PageHome from "app/(home)/page";
import PageArchiveVideo from "app/(archives)/videos/page";
import PageSingleVideo from "app/(singles)/(default)/video/page";
import PageAbout from "app/apropos/page";
import PageMission from "app/apropos/Mission/PageMission";
import PagePermis from "app/apropos/Permis/PagePermis";
import PageFondateur from "app/apropos/Fondateur/PageFondateur";
import PagePrix from "app/prix/page";
import PageServices from "app/services/page";
import PagePhotos from "app/photos/PagePhotos";
import PageContact from "app/(others)/contact/page";
import Page404 from "app/not-found";
import SiteHeader from "app/SiteHeader";

export const pages: Page[] = [
  { path: "/", component: PageHome },

  // archives page -------------------------------------------------------

  { path: "/videos/*", component: PageArchiveVideo },

  // single page -------------------------------------------------------

  { path: "/video/*", component: PageSingleVideo },

  // other pages -------------------------------------------------------
  
  { path: "/apropos", component: PageAbout },
  { path: "/mission", component: PageMission },
  { path: "/permis", component: PagePermis },
  { path: "/forfaits", component: PagePrix },
  { path: "/fondateur", component: PageFondateur },
  { path: "/services", component: PageServices },
  { path: "/photos", component: PagePhotos },
  { path: "/contact", component: PageContact },
  { path: "/page404", component: Page404 },

];

const MyRoutes = () => {
 
  return (
   
    <BrowserRouter >
      <SiteHeader />
      <Routes>
        {    
          pages.map(({ component: Component, path }, index) => {
            return <Route  key={index} element={<Component />} path={path} />;
        })
        
        }
        <Route path="*" element={<Page404 />} />
      </Routes>
     
      <Footer />
      <MusicPlayer />
    </BrowserRouter>

  );
};

export default MyRoutes;
